import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { useMeasure } from 'react-use';
import Link from 'next/link';
import { FREE_SEAT } from '@/config/monetization';
import featureFlags from '@/config/features';
import responsiveUtils from '@/utils/responsive';
import useSignupForm from '@/features/Auth/hooks/useSignupForm';
import useLoginForm from '@/features/Auth/hooks/useLoginForm';
import useGoogleOneTap from '@/features/Auth/hooks/useGoogleOneTap';
import ModalHoc from '@/components/ModalHoc';
import SignUpForm from '@/features/Auth/Signup/Form';
import LoginForm from '@/features/Auth/Login/Form';
import ClientOnly from '@/components/ClientOnly';
import GroupedStarReviews from '@/components/reviews/GroupedStarReviews';
import ButtonAuthWithGoogle from '@/components/FormElements/ButtonAuthWithGoogle';
import modalStyles from '@/components/ModalHoc/styles.module.scss';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L10 17.4142L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L10 14.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289Z",
      fill: "#12131A"
    })
  }));
};

CheckIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const SUPPORT_GOOGLE_AUTH = featureFlags.googleAuthentication;
const FEATURE_LIST = ['Save charts & data', 'Google Drive file picker', 'Interactive charts embeddables', 'Branded themes & color pallets', 'Convert charts to dashbboards'];

const AuthModal = _ref => {
  let {
    authType = 'signup',
    team,
    email,
    redirect = '',
    reviews = [],
    hasActiveSession,
    onGoogleAuthSuccess,
    onAuthSuccess,
    onChangeAuthType,
    onReviewsClick
  } = _ref;
  const [containerEl, {
    width
  }] = useMeasure();
  const isSingleColLayout = useMemo(() => responsiveUtils.isMediumOrSmaller(width), [width]);
  const [mainEl, {
    width: mainWidth
  }] = useMeasure();
  const isSmallMain = mainWidth < 600;
  const {
    error: loginError,
    isLoading: isLoginLoading,
    isGoogleLoginLoading,
    requestSignUp,
    handleLogin
  } = useLoginForm({
    redirect,
    redirectAfterLogin: false,
    onLoginSuccess: onAuthSuccess
  });
  const {
    errors: signupErrors,
    isLoading: isSignupLoading,
    isGoogleSignupLoading,
    setNewsletterChecked,
    handleEmailPassSignUp,
    handleGoogleSignUp
  } = useSignupForm({
    onGoogleAuthSuccess,
    onSignupSuccess: () => onAuthSuccess(true)
  });
  const googleAuthContext = authType === 'login' ? 'signin' : 'signup';
  const handleGoogleOneTapResponse = useCallback(response => {
    if (googleAuthContext === 'signin') {
      handleLogin('google', {
        credential: response.credential
      });
    } else {
      handleGoogleSignUp(response.credential);
    }
  }, [googleAuthContext, handleLogin, handleGoogleSignUp]);
  const {
    isOneTapPromptDisplayed,
    showOneTapPrompt
  } = useGoogleOneTap({
    authContext: googleAuthContext,
    onCredentialResponse: handleGoogleOneTapResponse
  });
  const isLoading = isLoginLoading || isSignupLoading || isGoogleLoginLoading || isGoogleSignupLoading;
  return /*#__PURE__*/_jsxs("div", {
    ref: containerEl,
    className: clsx(displayModalStyles.container, !isSingleColLayout ? styles['container--twoCols'] : ''),
    children: [/*#__PURE__*/_jsxs("div", {
      ref: mainEl,
      className: clsx(displayModalStyles.main, styles.main),
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.main__content,
        children: [/*#__PURE__*/_jsx("img", {
          src: "/img/auth/charts-visualization.webp",
          className: styles.chartsImage,
          alt: "Charts Visualization"
        }), /*#__PURE__*/_jsx("ul", {
          className: styles.features,
          children: FEATURE_LIST.map((feature, index) => /*#__PURE__*/_jsxs("li", {
            className: styles.feature,
            children: [/*#__PURE__*/_jsx(CheckIcon, {}), feature]
          }, `auth-feature-${index}`))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.main__footer,
        children: [/*#__PURE__*/_jsx("img", {
          src: "/img/auth/rising-star.webp",
          alt: "Rising Star Badge"
        }), reviews.length && onReviewsClick && !isSmallMain ? /*#__PURE__*/_jsx(ClientOnly, {
          children: /*#__PURE__*/_jsx(GroupedStarReviews, {
            reviews: reviews,
            onClick: onReviewsClick
          })
        }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("img", {
          src: "/img/auth/g2-leader.webp",
          alt: "G2 Leader Badge"
        })]
      })]
    }), /*#__PURE__*/_jsxs("aside", {
      className: clsx(displayModalStyles.sidebar, styles.sidebar),
      children: [/*#__PURE__*/_jsxs("header", {
        className: styles.sidebar__header,
        children: [/*#__PURE__*/_jsx("h5", {
          className: styles.heading,
          children: authType === 'signup' ? 'Sign Up' : 'Login'
        }), /*#__PURE__*/_jsxs("p", {
          className: styles.description,
          children: ["Free to start - save up to ", FREE_SEAT.chartLimit, " embeddable charts"]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.sidebar__main,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.sidebar__main__content,
          children: /*#__PURE__*/_jsxs("div", {
            className: "grid gap-4",
            children: [!SUPPORT_GOOGLE_AUTH ? null : authType === 'login' ? /*#__PURE__*/_jsx(ButtonAuthWithGoogle, {
              variant: "signin",
              requestSignUp: requestSignUp,
              disabled: isLoginLoading,
              text: isOneTapPromptDisplayed ? 'Waiting...' : undefined,
              helperText: isOneTapPromptDisplayed ? 'Please look for Google Sign In' : '',
              loading: isGoogleLoginLoading || isOneTapPromptDisplayed,
              onClick: () => showOneTapPrompt(() => handleLogin('google'))
            }) : /*#__PURE__*/_jsx(ButtonAuthWithGoogle, {
              variant: "signup",
              disabled: isSignupLoading,
              text: isOneTapPromptDisplayed ? 'Waiting...' : undefined,
              helperText: isOneTapPromptDisplayed ? 'Please look for Google Sign Up' : '',
              loading: isGoogleSignupLoading || isOneTapPromptDisplayed,
              onClick: () => showOneTapPrompt(handleGoogleSignUp)
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-4",
              children: [/*#__PURE__*/_jsx("span", {
                className: clsx('h-px w-full', styles.divider)
              }), /*#__PURE__*/_jsx("span", {
                className: "text-xs text-muted-foreground",
                children: "OR"
              }), /*#__PURE__*/_jsx("span", {
                className: clsx('h-px w-full', styles.divider)
              })]
            }), authType === 'login' ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(LoginForm, {
                disableRedirect: true,
                handleLogin: handleLogin,
                disabled: isGoogleLoginLoading,
                error: loginError
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.existingAccountLink,
                children: [/*#__PURE__*/_jsx("p", {
                  className: "m-0",
                  children: "Don't have an account yet?"
                }), /*#__PURE__*/_jsx("button", {
                  className: "underline",
                  disabled: isLoading,
                  onClick: () => onChangeAuthType === null || onChangeAuthType === void 0 ? void 0 : onChangeAuthType('signup'),
                  children: "Sign Up"
                })]
              })]
            }) : /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(SignUpForm, {
                teamId: team ? team.id : '',
                email: email,
                disabled: isGoogleSignupLoading,
                isLoading: isSignupLoading,
                errors: signupErrors,
                hasActiveSession: hasActiveSession,
                onSubmit: handleEmailPassSignUp,
                onNewsletterChange: setNewsletterChecked
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.existingAccountLink,
                children: [/*#__PURE__*/_jsx("p", {
                  className: "m-0",
                  children: "Already have an account?"
                }), /*#__PURE__*/_jsx("button", {
                  className: "underline",
                  disabled: isLoading,
                  onClick: () => onChangeAuthType === null || onChangeAuthType === void 0 ? void 0 : onChangeAuthType('login'),
                  children: "Log in"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-4 text-sm text-center text-muted-foreground",
                children: ["By continuing, you're agreeing to our", /*#__PURE__*/_jsx(Link, {
                  href: "/terms-and-conditions",
                  className: "ml-1 underline hover:text-primary",
                  children: "Terms and Privacy Policy."
                })]
              })]
            })]
          })
        })
      })]
    })]
  });
};

export default ModalHoc(AuthModal, {
  modalClass: modalStyles['container--big'],
  overlayclass: modalStyles['overlay--high']
});